<template>
  <div class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-5" style="z-index: 98765">
    <div class="max-w-3xl bg-white px-8 py-6">
      <slot>
        <svg class="spinner mr-5" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
        {{ $t('Načítá se zvolená doprava, počkejte prosím.') }}
      </slot>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.spinner {
  animation: rotate 2s linear infinite;

  width: 50px;
  height: 50px;

  & .path {
    stroke: #ba0c2f;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
